<div class="process-subscriptions-page">
  <div class="page-header page-header--no-search">
    <div class="page-header__title">
      <h2>{{ 'Subscriptions' | translate }}</h2>
      <p>{{ 'Manage schedules and event-driven starts' | translate }}</p>
    </div>
    <div class="header-actions">
      <input
        #catalogFile
        type="file"
        accept="application/json,.json"
        hidden
        (change)="onCatalogFileSelected($event)"
      />
      <app-export-button
        [loading]="catalogExportLoading"
        [disabled]="catalogExportLoading || catalogImportLoading"
        (export)="exportCatalog()"
      ></app-export-button>
      <app-secondary-button
        title="Import subscriptions"
        icon="file-import"
        [loading]="catalogImportLoading"
        [disable]="catalogExportLoading || catalogImportLoading || disablingModule() !== null"
        (action)="catalogFile.click()"
      ></app-secondary-button>
    </div>
  </div>

  @if (errorMessage) {
    <div class="error-message">{{ errorMessage | translate }}</div>
  }
  @if (catalogMessage) {
    <div class="catalog-message">{{ catalogMessage }}</div>
  }

  @if (moduleDisableResult(); as result) {
    <div class="catalog-message" role="status">{{ 'SUBSCRIPTIONS_MODULE_RESULT' | translate:result }}</div>
  }
  @if (moduleDisableError()) {
    <div class="error-message" role="alert">{{ 'SUBSCRIPTIONS_MODULE_LOAD_FAILED' | translate }}</div>
  }

  <section class="entity-panel entity-panel--subscription">
  <p class="module-disable-hint">{{ 'SUBSCRIPTIONS_MODULE_DISABLE_HINT' | translate }}</p>
  <div class="catalog-order">
    @for (chip of viewChips; track chip.id) {
      <button
        type="button"
        class="filter-chip"
        [class.active]="chip.selected"
        (click)="selectCatalogView(chip.id)"
      >
        <span>{{ chip.label | translate }}</span>
      </button>
    }
  </div>

  @if (!loading) {
    <app-orchestration-table-heading
      heading="Scheduled subscriptions"
      [query]="searchQuery"
      (queryChange)="onCatalogSearch($event)"
    >
      <div tableActions class="table-actions">
        <app-primary-button
          title="Create subscription"
          [disable]="disablingModule() !== null"
          icon="plus"
          (action)="create()"
        ></app-primary-button>
      </div>
    </app-orchestration-table-heading>
  }

  @if (loading) {
    <app-loading [loading]="true"></app-loading>
  } @else if (selectedView === 'gantt') {
    <app-subscription-schedule-gantt
      [items]="ganttItems"
      [now]="ganttNow"
      [groupChips]="groupChips"
      [selectedGroup]="selectedGroup"
      [windowHours]="ganttWindowHours"
      [moduleActiveCounts]="moduleActiveCounts()"
      [disablingModule]="disablingModule()"
      (disableModule)="disableModuleSubscriptions($event)"
      (selectedGroupChange)="onGanttGroup($event)"
      (windowHoursChange)="onGanttWindow($event)"
    ></app-subscription-schedule-gantt>
  } @else {
    <div class="module-actions">
      @for (group of moduleActions(); track group.id) {
        <div class="module-action">
          <strong><i [class]="group.icon" aria-hidden="true"></i> {{ group.labelKey | translate }}</strong>
          <app-secondary-button
            [title]="'SUBSCRIPTIONS_DISABLE_MODULE' | translate:{ count: group.activeCount }"
            icon="pause"
            [disable]="disablingModule() !== null || group.activeCount === 0"
            [loading]="disablingModule() === group.id"
            (action)="disableModuleSubscriptions(group.id)"
          ></app-secondary-button>
        </div>
      }
    </div>
    @if (groupChips.length) {
      <div class="group-chips" role="group">
        <button
          type="button"
          class="filter-chip"
          [class.active]="selectedGroup === 'all'"
          (click)="onGanttGroup('all')"
        >
          <span>{{ 'All' | translate }}</span>
        </button>
        @for (chip of groupChips; track chip.id) {
          <button
            type="button"
            class="filter-chip"
            [class.active]="selectedGroup === chip.id"
            (click)="onGanttGroup(chip.id)"
          >
            <i [class]="chip.icon" aria-hidden="true"></i>
            <span>{{ chip.labelKey | translate }}</span>
          </button>
        }
      </div>
    }
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>{{ 'Name' | translate }}</th>
            <th>{{ 'Schedule' | translate }}</th>
            <th>{{ 'Status' | translate }}</th>
            <th>{{ 'Next run' | translate }}</th>
            <th>{{ 'Last run' | translate }}</th>
            <th>{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of subscriptionRows; track row.item.id) {
            <tr>
              <td class="identity-cell">
                <app-orchestration-identity-cell
                  [name]="row.name"
                  [nameUrl]="row.detailsUrl"
                  [lines]="row.identityLines"
                ></app-orchestration-identity-cell>
              </td>
              <td>
                <strong>
                  <i class="pi pi-clock schedule-icon" aria-hidden="true"></i>
                  {{ row.item.cronExpression | quartzCronLabel }}
                </strong>
                <small>{{ row.item.timeZoneId | timeZoneLabel }}</small>
              </td>
              <td><p-tag [value]="(row.item.isActive ? 'Active' : 'Inactive') | translate" [severity]="row.item.isActive ? 'success' : 'warn'"></p-tag></td>
              <td>{{ row.item.nextFireAt ? (row.item.nextFireAt | dateFormatLang:translate.currentLang:true) : '—' }}</td>
              <td>{{ row.item.lastTriggeredAt ? (row.item.lastTriggeredAt | dateFormatLang:translate.currentLang:true) : '—' }}</td>
              <td class="actions">
                <app-secondary-button icon="play" title="Run now" [disable]="disablingModule() !== null" (action)="runNow(row.item)"></app-secondary-button>
                <app-secondary-button icon="pencil" title="Edit" [disable]="disablingModule() !== null" (action)="edit(row.item)"></app-secondary-button>
                <app-secondary-button icon="copy" title="Create copy" [disable]="disablingModule() !== null" (action)="copy(row.item)"></app-secondary-button>
                <app-secondary-button icon="trash" title="Delete" [disable]="disablingModule() !== null" (action)="remove(row.item)"></app-secondary-button>
              </td>
            </tr>
          } @empty {
            <tr><td colspan="6" class="empty-state">{{ emptySubscriptionsMessage | translate }}</td></tr>
          }
        </tbody>
      </table>
    </div>
  }

  </section>

  <section class="event-triggers-section entity-panel entity-panel--event">
    <div class="section-header">
      <app-orchestration-table-heading
        heading="Event-driven process triggers"
        [query]="triggerSearchQuery"
        (queryChange)="onTriggerSearch($event)"
      >
        <p>{{ 'Start a process when another assignment or domain operation emits an event' | translate }}</p>
        <div tableActions class="table-actions">
          <app-primary-button
            title="Create event trigger"
            icon="plus"
            (action)="createEventTrigger()"
          ></app-primary-button>
        </div>
      </app-orchestration-table-heading>
    </div>

    @if (!loading) {
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>{{ 'Name' | translate }}</th>
              <th>{{ 'Status' | translate }}</th>
              <th>{{ 'Executions' | translate }}</th>
              <th>{{ 'Last run' | translate }}</th>
              <th>{{ 'Actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of eventTriggerRows; track row.item.id) {
              <tr>
                <td class="identity-cell">
                  <app-orchestration-identity-cell [name]="row.name" [lines]="row.identityLines"></app-orchestration-identity-cell>
                </td>
                <td><p-tag [value]="(row.item.isActive ? 'Active' : 'Inactive') | translate" [severity]="row.item.isActive ? 'success' : 'warn'"></p-tag></td>
                <td>
                  <strong>{{ row.item.executionCount }}</strong>
                  <small>{{ 'Succeeded' | translate }}: {{ row.item.successfulExecutionCount }}, {{ 'Failed' | translate }}: {{ row.item.failedExecutionCount }}</small>
                </td>
                <td>{{ row.item.lastTriggeredAt ? (row.item.lastTriggeredAt | dateFormatLang:translate.currentLang:true) : '—' }}</td>
                <td class="actions">
                  <button pButton type="button" icon="pi pi-history" [text]="true" [title]="'Execution audit' | translate" (click)="showEventTriggerAudit(row.item)"></button>
                  <button pButton type="button" icon="pi pi-pencil" [text]="true" [title]="'Edit' | translate" (click)="editEventTrigger(row.item)"></button>
                  <button pButton type="button" icon="pi pi-trash" severity="danger" [text]="true" [title]="'Delete' | translate" (click)="removeEventTrigger(row.item)"></button>
                </td>
              </tr>
            } @empty {
              <tr><td colspan="5" class="empty-state">{{ emptyEventTriggersMessage | translate }}</td></tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</div>

<app-subscription-form-dialog (saved)="onSubscriptionSaved()"></app-subscription-form-dialog>

<p-dialog [resizable]="false" [draggable]="false"
  [(visible)]="eventTriggerDialogVisible"
  [modal]="true"
  [style]="{ width: 'min(820px, 94vw)' }"
  [header]="(editingEventTrigger ? 'Edit event trigger' : 'Create event trigger') | translate">
  <div class="form-grid">
    <label class="full-width">
      <span>{{ 'Name' | translate }}</span>
      <input type="text" [(ngModel)]="eventTriggerForm.name" />
    </label>
    <label>
      <span>{{ 'Event' | translate }}</span>
      <select [(ngModel)]="eventTriggerForm.eventKey" [disabled]="!!editingEventTrigger" (ngModelChange)="onEventChanged()">
        @for (event of eventDefinitions; track event.key) {
          <option [value]="event.key">{{ event.displayName | translate }} — {{ event.key }}</option>
        }
      </select>
    </label>
    <label>
      <span>{{ 'Source process' | translate }}</span>
      <select [(ngModel)]="eventTriggerForm.sourceProcessDefinitionKey" [disabled]="!!editingEventTrigger">
        @if (eventTriggerForm.eventKey !== 'assignment.completed') {
          <option value="">{{ 'Any process' | translate }}</option>
        }
        @for (process of processes; track process.key) {
          <option [value]="process.key">{{ (process.displayName || process.key) | translate }} — {{ process.key }}</option>
        }
      </select>
    </label>
    <label class="full-width">
      <span>{{ 'Target process' | translate }}</span>
      <select [(ngModel)]="eventTriggerForm.targetProcessDefinitionKey" [disabled]="!!editingEventTrigger" (ngModelChange)="onEventChanged()">
        @for (process of processes; track process.key) {
          <option [value]="process.key">{{ (process.displayName || process.key) | translate }} — {{ process.key }}</option>
        }
      </select>
    </label>
    @if (currentEventDefinition(); as event) {
      <div class="full-width event-help">
        <strong>{{ event.displayName | translate }}</strong>
        <p>{{ event.description | translate }}</p>
        <span>{{ 'Event payload example' | translate }}</span>
        <pre><code>{{ event.samplePayloadJson | prettyJson }}</code></pre>
      </div>
    }
    @if (editingEventTrigger) {
      <div class="full-width safe-input">
        <span>{{ 'Current safe parameter preview' | translate }}</span>
        <pre><code>{{ editingEventTrigger.safeParameterPreviewJson | prettyJson }}</code></pre>
      </div>
    }
    <label class="full-width">
      <span>{{ (editingEventTrigger ? 'New parameter template (leave empty to keep current)' : 'Parameter template') | translate }}</span>
      <textarea rows="10" [(ngModel)]="eventTriggerForm.parameterTemplateJson"></textarea>
      <small>{{ 'Event parameter placeholder help' | translate }} <code>{{ eventParameterPlaceholder }}</code></small>
    </label>
    <label class="full-width checkbox-label">
      <input type="checkbox" [(ngModel)]="eventTriggerForm.isActive" />
      <span>{{ 'Active' | translate }}</span>
    </label>
  </div>
  <ng-template #footer>
    <button pButton type="button" severity="secondary" [text]="true" [label]="'Cancel' | translate" (click)="eventTriggerDialogVisible = false"></button>
    <button
      pButton
      type="button"
      [loading]="saving"
      [disabled]="!eventTriggerForm.name || !eventTriggerForm.eventKey || !eventTriggerForm.targetProcessDefinitionKey || (eventTriggerForm.eventKey === 'assignment.completed' && !eventTriggerForm.sourceProcessDefinitionKey)"
      [label]="'Save' | translate"
      (click)="saveEventTrigger()"></button>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [draggable]="false"
  [(visible)]="eventTriggerAuditVisible"
  [modal]="true"
  [style]="{ width: 'min(980px, 96vw)' }"
  [header]="'Event trigger execution audit' | translate">
  @if (selectedEventTrigger) {
    <p><strong>{{ selectedEventTrigger.name }}</strong></p>
  }
  <div class="table-wrapper audit-table">
    <table>
      <thead><tr><th>{{ 'Started At' | translate }}</th><th>{{ 'Status' | translate }}</th><th>{{ 'Event ID' | translate }}</th><th>{{ 'Source assignment' | translate }}</th><th>{{ 'Created assignment' | translate }}</th><th>{{ 'Safe parameters' | translate }}</th><th>{{ 'Error' | translate }}</th></tr></thead>
      <tbody>
        @for (execution of eventTriggerExecutions; track execution.item.id) {
          <tr>
            <td>{{ execution.item.startedAt | dateFormatLang:translate.currentLang:'seconds' }}</td>
            <td><p-tag [value]="(execution.item.state || '—') | translate" [severity]="execution.item.state === 'Succeeded' ? 'success' : execution.item.state === 'Failed' ? 'danger' : 'info'"></p-tag></td>
            <td>
              <app-copyable-identifier
                [value]="execution.item.eventId || ''"
                [link]="execution.productAnalysisUrl"
              ></app-copyable-identifier>
            </td>
            <td>
              <app-copyable-identifier
                [value]="execution.item.sourceAssignmentId || ''"
                [link]="execution.sourceAssignmentUrl"
              ></app-copyable-identifier>
            </td>
            <td>
              <app-copyable-identifier
                [value]="execution.item.targetAssignmentId || ''"
                [link]="execution.targetAssignmentUrl"
              ></app-copyable-identifier>
            </td>
            <td><pre><code>{{ execution.item.safeParametersJson | prettyJson }}</code></pre></td>
            <td class="audit-error">{{ execution.item.error || '—' }}</td>
          </tr>
        } @empty {
          <tr><td colspan="7" class="empty-state">{{ 'No event trigger executions found' | translate }}</td></tr>
        }
      </tbody>
    </table>
  </div>
</p-dialog>
